import * as moment from 'moment';
import { isNullOrUndefined, isObject, isString } from 'util';
import { get } from 'lodash';

import { DropdownItem } from '@gosuite/selects';

import { Group } from '../../xena/core/shared/models/groups/groups.model';
import { HotelviewDataIdAttributes } from '../models/hotelview/data-id-attributes.model';
import { Agency } from '../services/agencies/agencies.model';


export function fetchFromObject(obj, prop) {
	if (isNullOrUndefined(obj)) {
		return false;
	}

	const _index = prop.indexOf('.');

	if (_index > -1) {
		return fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
	}

	return obj[prop];
}

export function htmlUtf8Decoder(encodedStr): string {
	const parser: DOMParser = new DOMParser();
	const dom: Document = parser.parseFromString('<!doctype html><body>' + encodedStr, 'text/html');

	return dom.body.textContent;
}

export function sortAlphabetically(a, b): number {
	return a.displayName.toUpperCase() > b.displayName.toUpperCase() ? 1 : -1;
}

export function bestMatchToTop(searchString: string, results: Array<DropdownItem>): Array<DropdownItem> {
	searchString = isString(searchString) ? searchString.trim().toUpperCase() : '';

	if (!searchString) {
		return results.sort(sortAlphabetically);
	}

	const bestMatches: Array<DropdownItem> = [];
	const goodMatches: Array<DropdownItem> = [];
	const otherResults: Array<DropdownItem> = [];

	results.forEach(item => {
		if (item.rawValue === searchString) {
			bestMatches.push(item);
		} else if (item.rawValue.startsWith(searchString) || item.rawValue.indexOf(searchString) !== -1) {
			goodMatches.push(item);
		} else {
			otherResults.push(item);
		}
	});

	return bestMatches.concat(goodMatches, otherResults.sort(sortAlphabetically));
}

export function createHotelValidationCacheId(offer: Group): string {
	if (!isObject(offer)) {
		return '';
	}

	const hotelId = offer.id.substr(0, 32);

	return hotelId + moment(offer.startDate).format('YYYY-MM-DD') + offer.duration;
}

export function parseHotelviewDataIdAttributesKey(dataIdAttributes: HotelviewDataIdAttributes): string {
	return Object.keys(dataIdAttributes).map(key => dataIdAttributes[key]).join('-');
}

export function isNumeric(value): boolean {
	if (typeof value === 'number' && !isNaN(value)) {
		return true;
	}

	if (typeof value === 'string') {
		const parseResult = Number(value);

		return !isNaN(parseResult);
	}

	return false;
}

export function isGtsAgency(agency: Agency): boolean {
	if (!isObject(agency) || !isNumeric(agency.agentId)) {
		return false;
	}

	return [142229, 144235, 144236].indexOf(agency.agentId) !== -1;
}

export function showAdminForGts(config): boolean {
	if (!isObject(config)) {
		return false;
	}

	return get(config, 'gts.admin', false) || isGtsBabo(config);
}

export function isGtsBabo(config): boolean {
	if (!isObject(config)) {
		return false;
	}

	return get(config, 'gts.babo', false);
}

export function showNeoForGTS(config): boolean {
	if (!isObject(config)) {
		return false;
	}

	return get(config, 'gts.neo', false) || isGtsBabo(config);
}



// WEBPACK FOOTER //
// ./src/app/shared/help/functions.ts